import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  setDefaultEventProperties: () => {},
  trackEvent: () => {},
  trackPageview: () => {},
  trackDetailsPageview: () => {},
  trackFilterView: () => {},
  trackInteraction: () => {},
  trackDetailsInteraction: () => {}
});